import React, { FC } from 'react'
import Button from 'components/Common/Button'
import { CardBlock } from 'components/Owner/Tools/style'
import Arrow from 'assets/svgs/Arrow.svg'
import { getImageUrl, onLaunchTool } from 'utils/helper'
import { Tool } from '__generated__/api-types-and-hooks'
import { ReduxAction } from 'store/types'

interface IAllToolsBlockProps {
  tool: Tool
  getOAuthUrlAction: ReduxAction<{ calendar: string; targetOrigin?: string }>
  setActiveConnectingTool: (tool: Tool) => void
}
const AllToolsBlock: FC<IAllToolsBlockProps> = ({
  tool,
  getOAuthUrlAction,
  setActiveConnectingTool,
}) => {
  const connectTools = (tool) => {
    setActiveConnectingTool(tool)
    getOAuthUrlAction({ calendar: tool, targetOrigin: window.location.href })
  }

  return (
    <>
      <CardBlock className="w-full xs:max-w-[100%] sm:max-w-[294px]  h-[280px] flex flex-col gap-[18px] border border-primary-outline rounded-[10px] bg-white  xs:p-4  md:p-6 lg:p-9">
        <span className="flex justify-center">
          <img
            src={getImageUrl(tool.imageUrl)}
            className="h-[96px] w-[96px]"
            alt={`${tool.toolName}`}
          />
        </span>
        <p className="text-base text-primary-text text-center leading-6">{tool.toolName}</p>
        {tool.isConnected ? (
          // check button -- clean up custom style
          <Button
            icon={Arrow}
            label="Launch"
            variant="primary"
            className="px-5 gap-2 w-full"
            onClick={() => onLaunchTool(tool)}
          />
        ) : (
          // check button - clean up custom style -- full width?
          <Button
            label={`${tool.cyclrToolId ? 'Connect' : 'Launch'} `}
            variant={`${tool.cyclrToolId ? 'secondary' : 'primary'}`}
            className="px-3 mt-auto"
            onClick={() => {
              tool.cyclrToolId ? connectTools(tool.toolName) : onLaunchTool(tool)
            }}
          />
        )}
      </CardBlock>
    </>
  )
}

export default AllToolsBlock
